import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom'
import Nav from './components/Nav'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import StatePage from './pages/StatePage'
import states from './generated/states.json'

function StateRoute() {
  const { slug } = useParams()
  const state = states.find((s) => s.slug === slug)
  if (!state) return <Navigate to="/" replace />
  return <StatePage state={state} states={states} />
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/states/:slug" element={<StateRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}
